import Span from '@/components/common/textElements/Span.tsx'
import StageNumberSpan from '@/components/common/StageNumberSpan.tsx'
import { ChevronDown } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { useProjectStageStore } from '@/components/common/menu/lib/store/useProjectStageStore.tsx'
import { useProjectStageFiltersStore } from '@/components/common/menu/lib/store/useProjectStageFilters.ts'

export default function NavStagesTriggerLabel() {
  const { t } = useTranslation()
  const currProjectStage = useProjectStageStore(state => state.currProjectStage)
  const stagesProperties = useProjectStageFiltersStore(state => state.stagesProperties)
  const selected = stagesProperties.find(stage => stage.value == String(currProjectStage?.id))

  return (
    <span className={`flex items-center gap-x-1.5 py-1`}>
      <Span className={`truncate text-xs md:text-sm`}>
        {selected?.label ?? t('navigation.selectStage')}
      </Span>
      <StageNumberSpan
        fullNumber={false}
        className={`flex items-center text-xs md:text-sm`}
        variant={`muted`}
        stage={currProjectStage}
      />

      {stagesProperties.length > 0 && (
        <ChevronDown className={`ml-auto size-3.5 md:size-4`} />
      )}
    </span>
  )
}
